import { render } from "./BaseDisabledRadio.vue?vue&type=template&id=5c0033a4&scoped=true"
import script from "./BaseDisabledRadio.vue?vue&type=script&lang=js"
export * from "./BaseDisabledRadio.vue?vue&type=script&lang=js"

import "./BaseDisabledRadio.vue?vue&type=style&index=0&id=5c0033a4&lang=scss&scoped=true"

import exportComponent from "/Users/maksimzugan/code/nacd-3-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c0033a4"]])

export default __exports__